"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = createStylesheetLoader;
var request_sender_1 = require("@bigcommerce/request-sender");
var browser_support_1 = require("./browser-support");
var stylesheet_loader_1 = require("./stylesheet-loader");
function createStylesheetLoader() {
    return new stylesheet_loader_1.default(new browser_support_1.default(), (0, request_sender_1.createRequestSender)());
}
//# sourceMappingURL=create-stylesheet-loader.js.map